import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { User, CheckAdmin } from '../api/models';
import { AdminService } from '../api/services';

@Injectable()
export class AdminGuard implements CanActivate {
  public user: User = null;
  public checkAdmin: CheckAdmin = null;

  constructor(private router: Router, private apiAdmin: AdminService) {
    this.apiAdmin.checkIsAdmin().subscribe(
      res => {
        this.checkAdmin = res;
        this.checkAdmin.checkit = atob(res.checkit);
      },
      err => {
        console.log('err');
      },
      () => { }
    );
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    this.apiAdmin.checkIsAdmin().subscribe(
      res => {
        this.checkAdmin = res;
        this.checkAdmin.checkit = atob(res.checkit);
      },
      err => {
        console.log('err');
      },
      () => { }
    );

    if (this.checkAdmin) {
      if (this.checkAdmin.checkit === 'iknowyouyouyou3105@@@') {
        return true;
      }
    }
    // not logged in so redirect to login page
    this.router.navigate(['/home']);
    return false;
  }
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/guards/admin.guard.ts